export function decimal(value) {
	return /^[0-9.-]*$/.test(value);
}

export function numeric(value) {
	return /^[0-9]*$/.test(value);
}



// WEBPACK FOOTER //
// ./src/utils/validators.js